import { InvoiceTemplateDetail } from "@common/schemas/domains/invoice/invoice-template.schema";
import { Entity } from "@common/types/entity";
import {
    createNativeInvoiceFormState,
    CreateNativeInvoiceFormStateResult,
} from "./createNativeInvoiceFormState";
import { lineCodingFromTemplateAccounting } from "./lineAccountingToLineCoding";
import { NativeInvoiceCustomer } from "./nativeInvoiceFormTypes";

export function customerFromTemplateDetail(
    detail: InvoiceTemplateDetail,
): NativeInvoiceCustomer | null {
    if (!detail.counterpartyId) {
        return null;
    }
    const to = detail.renderSnapshot.to;
    return {
        id: detail.counterpartyId,
        name: to.businessName ?? to.name ?? "",
        email: to.email ?? "",
        cc: detail.counterpartyCc,
        bcc: detail.counterpartyBcc,
        phoneNumber: to.phoneNumber ?? "",
        street: to.address.street ?? undefined,
        street2: to.address.street2 ?? undefined,
        city: to.address.city ?? undefined,
        state: to.address.state ?? undefined,
        postalCode: to.address.postalCode ?? undefined,
        country: to.address.country ?? undefined,
    };
}

export function createNativeInvoiceFormStateFromTemplate({
    detail,
    entity,
    primaryAccrualLedgerId,
    incomeAccountLedgerId,
}: {
    detail: InvoiceTemplateDetail;
    entity: Entity;
    primaryAccrualLedgerId?: string;
    incomeAccountLedgerId?: string;
}): CreateNativeInvoiceFormStateResult {
    const lineCodingByLineId = lineCodingFromTemplateAccounting({
        lineAccounting: detail.lineAccounting,
        primaryAccrualLedgerId,
        incomeAccountLedgerId,
    });
    const seeded = createNativeInvoiceFormState({
        mode: "edit",
        snapshot: detail.renderSnapshot,
        entity,
        customer: customerFromTemplateDetail(detail),
        logoPreviewUrl: detail.renderSnapshot.logoUrl,
        lineCodingByLineId,
        sendingEmailId: detail.sendingEmailId,
        collectPayment: detail.collectPayment,
        stripeFinancialAccountId: detail.stripeFinancialAccountId,
        acceptedPaymentMethods: detail.acceptedPaymentMethods,
        emailSnapshot: detail.emailSnapshot,
        termType: detail.termType,
        customTerm: detail.customTerm,
        isEmailSubjectAutomatic: detail.isEmailSubjectAutomatic,
        isEmailMessageAutomatic: detail.isEmailMessageAutomatic,
        adjustmentSettings: detail.adjustmentSettings,
    });
    return {
        raw: {
            ...seeded.raw,
            invoiceNumberOverride: null,
            scheduleEnabled: false,
            scheduledSendAt: "",
        },
        lineCodingBaselineByLineId: seeded.lineCodingBaselineByLineId,
    };
}
